<!-- 文本项组件 -->
<template>
  <ItemCard :title="title" :index="index" :showRemove="showRemove" @remove-item="$emit('remove-item', $event)">
    <div class="item-body">
      <el-input type="textarea" rows="3" placeholder="请输入内容" v-model="text" show-word-limit>
      </el-input>
    </div>
  </ItemCard>
</template>

<script>
import ItemCard from "./ItemCard";
import editMixin from '../mixins/editMixin';

export default {
  name: 'TextCard',
  mixins: [editMixin],  
  components: {
    ItemCard
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    index: {
      type: Number,
      default: 0
    },
    showRemove: {
      type: Boolean,
      default: true
    },
    value: {
      type: Object,
      default: () => ({ text: '' })
    }
  },
  computed: {
    text: {
      get() {
        return this.value.text
      },
      set(val) {
        this.updateValue({ text: val })
      }
    }
  },
}
</script>

<style lang="scss" scoped>
.item-body {
  .el-input {
    width: 100%;
    max-width: none;
    
    &.el-textarea {
      .el-textarea__inner {
        min-height: 80px;
        border-radius: 4px;
        border-color: #dcdfe6;
        transition: all 0.3s ease;
        font-size: 12px;
        line-height: 1.4;
        
        &:focus {
          border-color: #409eff;
          box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
        }
      }
    }
  }
}
</style>
